module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-8.9ba4081a.svg";